<template>
  <div class="w-full lg:w-1/2 mb-4 lg:px-2">
    <label
      for="person_name"
      class="block text-sm font-medium leading-5 text-gray-700"
      >Nombre</label
    >
    <div class="mt-1 relative rounded-md shadow-sm">
      <input
        id="person_name"
        v-model.trim.lazy="$v.form.name.$model"
        type="text"
        required
        class="form-input block w-full sm:text-sm sm:leading-5"
        :class="{
          'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
            $v.form.name.$error,
        }"
      />
      <div
        v-if="$v.form.name.$error"
        class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
      >
        <svg
          class="h-5 w-5 text-red-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
